import { checkCustomFilter, CustomFilter } from '../sei-search-init';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    List?: any;
  }
}

interface MultiFilter {
  type: string;
  value: string;
}

interface ListOptions {
  valueNames: string[];
  fuzzySearch: {
    searchClass: string;
    location: number;
    distance: number;
    threshold: number;
    multiSearch: boolean;
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const listJSPage = document.querySelectorAll<HTMLElement>('.search');
  if (listJSPage.length === 0 || typeof window.List !== 'function') return;

  const listOptions: ListOptions = {
    valueNames: ['lastNameFilter', 'typeFilter'],
    fuzzySearch: {
      searchClass: 'search',
      location: 0,
      distance: 200,
      threshold: 0.4,
      multiSearch: true
    }
  };

  const assetsElement = document.querySelector<HTMLElement>('.assets');
  if (!assetsElement) return;

  const assetList = new window.List(assetsElement, listOptions);

  assetList.on('updated', () => {
    window.setTimeout(setListCount, 15);
  });

  const sortVar: string = 'lastNameFilter';
  assetList.sort(sortVar, {
    order: (sortVar === 'yearFilter' || sortVar === 'dateSortFilter') ? 'desc' : 'asc'
  });

  function setListCount(): void {
    const listCount = assetList.matchingItems.length;
    const resultCountEl = document.getElementById('resultCount');
    if (resultCountEl) {
      resultCountEl.innerHTML = `${listCount} Results`;
    }

    if (listCount === 0 && !document.getElementById('noResultsMessage')) {
      const noResults = document.createElement('li');
      noResults.id = 'noResultsMessage';
      noResults.textContent = 'No results available for the selected filters.';
      document.querySelector('.list')?.appendChild(noResults);
    }

    const letters: string[] = [];
    for (let i = 0; i < listCount; i++) {
      const val = assetList.matchingItems[i]._values['lastNameFilter']?.trim();
      if (val) letters.push(val[0]);
    }
  }

  const resultsPerPage = document.getElementById('resultsPerPage') as HTMLSelectElement | null;
  if (resultsPerPage) {
    resultsPerPage.addEventListener('change', () => {
      const selection = parseInt(resultsPerPage.value, 10);
      assetList.show(1, selection);
    });
  }

  function filterList(): void {
    const multiFilter: MultiFilter[] = [];

    function filterCheck(el: HTMLElement) {
      const type = el.dataset.type;
      return (value: string) => value === type;
    }

    const checkedBoxes = document.querySelectorAll<HTMLInputElement>(
      "input[type='checkbox'][class*='filterCheckbox']:checked"
    );

    checkedBoxes.forEach((checkbox) => {
      const type = checkbox.dataset.type ?? '';
      const specialFilters = [
        'sponsoredFilter', 'renewalFilter', 'durationFilter', 'examFilter',
        'deliveryFilter', 'dateFilter', 'productSuiteFilter', 'careerLocationFilter',
        'certificationTypeFilter', 'accessFilter'
      ];

      if (specialFilters.some(filterCheck(checkbox))) {
        multiFilter.push({ type, value: checkbox.value.trim() });
      } else {
        const parentText = checkbox.parentElement?.textContent?.trim() ?? '';
        multiFilter.push({ type, value: parentText });
      }
    });

    const selectedFilters = document.querySelectorAll<HTMLElement>('.lastNameFilter > .filter-selected');
    selectedFilters.forEach((el) => {
      multiFilter.push({ type: el.dataset.type ?? '', value: el.textContent?.trim() ?? '' });
    });

    assetList.filter((item: { values: () => Record<string, string>; found?: boolean }) => {
      type CFConstructor = new (list: MultiFilter[], filterName: string) => { values: string[]; type: string };
      const CF = CustomFilter as unknown as CFConstructor;
      return (
        checkCustomFilter(new CF(multiFilter, 'lastNameFilter'), item) &&
        checkCustomFilter(new CF(multiFilter, 'typeFilter'), item)
      );
    });

    setListCount();
  }

  const filterNames = document.querySelectorAll<HTMLElement>('.lastNameFilter > .filter-name');
  filterNames.forEach((el) => {
    el.addEventListener('click', () => {
      const sel = el.getAttribute('data-selected');
      if (sel === 'true') {
        el.setAttribute('data-selected', 'false');
        el.classList.remove('filter-selected');
      } else {
        const firstSelected = document.querySelector<HTMLElement>('[data-selected="true"]');
        if (firstSelected) {
          firstSelected.classList.remove('filter-selected');
          firstSelected.setAttribute('data-selected', 'false');
        }
        el.setAttribute('data-selected', 'true');
        el.classList.add('filter-selected');
      }
      filterList();
    });
  });

  const url = window.location.href;
  const searchRE = new RegExp('searchstring=([^&##]*)(&|$|##)');
  const result = searchRE.exec(url.toLowerCase());

  if (result && result.length >= 1) {
    const keyWord = decodeURI(result[1].replace('%26', '&'));
    const filterKeyword = document.getElementById('filter-keyword') as HTMLInputElement | null;
    if (filterKeyword) {
      filterKeyword.value = keyWord;
    }
    assetList.fuzzySearch(keyWord);
  }
});
